var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-archive_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.847000 0 0 0 0 0.847000 0 0 0 0 0.847000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-archive_svg__a)",
    transform: "translate(-16 -69)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B5B5B5",
    d: "M27.729 70.091c.13 0 .249.069.314.18l.014.026 3.445 7.167.01.026.006.019a.17.17 0 01.01.032l.003.016.005.036.002.029v5.936a.364.364 0 01-.336.363H16.909a.362.362 0 01-.362-.336l-.001-.027v-5.936l.002-.029.002-.02.005-.032.005-.016.011-.035.01-.026 3.446-7.167a.364.364 0 01.298-.205l.03-.001h7.374zm-7.965 7.894h-2.491v5.21H30.81v-5.21h-2.49a2.55 2.55 0 01-2.483 2.384l-.058.001h-3.475a2.548 2.548 0 01-2.536-2.327l-.004-.058zm7.736-7.167h-6.917l-3.096 6.44h2.635c.192 0 .349.148.363.337v.23c0 .985.789 1.79 1.768 1.817h3.527a1.82 1.82 0 001.817-1.767v-.253c0-.192.15-.35.337-.363h2.662L27.5 70.818zm.474 4.309a.364.364 0 01.027.726l-.027.001h-7.865a.364.364 0 01-.027-.726l.027-.001h7.865zm-1.125-2.508a.364.364 0 01.027.727h-5.642a.363.363 0 01-.027-.726h5.642z"
  }))));
}

export default __webpack_public_path__ + "e76d1bd63a160111107c4380d2be168e.svg";
export { SvgIconArchive as ReactComponent };